import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

const DriverDashboard = () => {
  const { user } = useAuth();

  const { data: bookings, isLoading } = useQuery({
    queryKey: ["my_bookings", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("bookings")
        .select("*, availability_slots(*), charging_spots(title, address)")
        .eq("driver_id", user!.id)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
    enabled: !!user,
  });

  return (
    <div className="space-y-8">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Fahrer-Dashboard</h1>
          <p className="text-sm text-muted-foreground">Ihre Buchungen im Überblick</p>
        </div>
        <Link to="/search">
          <Button className="gap-2"><Search className="h-4 w-4" /> Ladepunkt suchen</Button>
        </Link>
      </div>

      {isLoading && <p className="text-sm text-muted-foreground">Lädt…</p>}
      {bookings?.length === 0 && (
        <div className="rounded-lg border border-border bg-muted/30 p-8 text-center">
          <p className="text-muted-foreground">Noch keine Buchungen. Suchen Sie einen Ladepunkt!</p>
        </div>
      )}

      <div className="space-y-3">
        {bookings?.map((b) => {
          const slot = b.availability_slots;
          const spot = b.charging_spots as any;
          return (
            <div key={b.id} className="rounded-xl border border-border bg-card p-5">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-semibold text-foreground">{spot?.title ?? "Ladepunkt"}</h3>
                  <p className="text-sm text-muted-foreground">{spot?.address}</p>
                  {slot && (
                    <p className="mt-1 text-sm text-muted-foreground">
                      {format(new Date(slot.start_time), "dd.MM.yyyy HH:mm", { locale: de })} – {format(new Date(slot.end_time), "HH:mm", { locale: de })} Uhr
                    </p>
                  )}
                </div>
                <div className="text-right">
                  <p className="font-semibold text-foreground">{b.amount.toFixed(2)} €</p>
                  <span className={`mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium ${
                    b.status === "paid" ? "bg-primary/10 text-primary" :
                    b.status === "cancelled" ? "bg-destructive/10 text-destructive" :
                    "bg-muted text-muted-foreground"
                  }`}>
                    {b.status === "paid" ? "Bezahlt" : b.status === "cancelled" ? "Storniert" : "Ausstehend"}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DriverDashboard;
